import React from "react"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"
import MultipleImageFieldThumb from "./MultipleImageFieldThumb"
import { AddIcon } from "../../Icons"
import "./MultipleImageField.css"

class MultipleImageField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hash: Date.now(),
      allowMultiple: true,
      files: [],
      target: null
    }
    this.dropzoneRef = React.createRef()
    this.active = false
    this.handleDrop = this.handleDrop.bind(this)
    this.handleDragStart = this.handleDragStart.bind(this)
  }

  handleClick(e) {
    e.preventDefault()
  }

  openFileUpload(id) {
    this.setState(
      state => ({ ...state, target: id, allowMultiple: false }),
      () => {
        this.dropzoneRef.current.open()
      }
    )
  }

  handleDragStart() {
    console.log("Drag Start")
    this.setState({ target: null, allowMultiple: true })
  }

  handleDeleteImage(i) {
    const {
      field: { name, value },
      form: { setFieldValue }
    } = this.props
    const uploadedImages = [...value]
    uploadedImages.splice(i, 1)
    setFieldValue(name, uploadedImages)
  }

  async handleDrop(acceptedFiles) {
    const {
      field: { name, value },
      form: { setFieldValue },
      max
    } = this.props

    // do nothing if no files
    if (acceptedFiles.length === 0) {
      return
    }

    let filesToProcess = acceptedFiles
    if (
      acceptedFiles.length + value.length > max &&
      this.state.target === null
    ) {
      filesToProcess = acceptedFiles.slice(0, max - value.length)
    }

    // on drop we add to the existing files
    const uploadedFiles = [...value]
    const next = value.length
    filesToProcess.forEach(async (file, i) => {
      const id = this.state.target !== null ? this.state.target : i + next
      try {
        uploadedFiles[id] = file
        setFieldValue(name, uploadedFiles)
        this.setState({
          target: null,
          files: uploadedFiles,
          allowMultiple: true
        })
      } catch (error) {
        console.log("Photo Upload Error: ", error.response || error)
      }
    })
  }

  componentDidMount() {
    this.active = true
  }

  componentWillUnmount() {
    this.active = false
  }

  render() {
    const { icon: Icon, max } = this.props

    const thumbs = []
    const { value } = this.props.field
    for (let i = 0; i < max; i++) {
      if (value[i]) {
        if (value[i] instanceof File) {
          thumbs[i] = {
            value: (value[i] && value[i] && value[i].preview) || ""
          }
        } else {
          thumbs[i] = { value: value[i] }
        }
      }
    }

    return (
      <span className="MultipleImageField">
        <Dropzone
          ref={this.dropzoneRef}
          onClick={this.handleClick.bind(this)}
          className="drop-zone"
          accept="image/*"
          multiple={this.state.allowMultiple}
          maxSize={2097152}
          onDragStart={this.handleDragStart}
          onDrop={this.handleDrop}
          onDropRejected={() => {
            console.log("Drop rejected.")
          }}
        >
          {thumbs.map(
            (t, i) =>
              t.uploading ? (
                <div key={i}>Uploading...</div>
              ) : (
                t.value && (
                  <MultipleImageFieldThumb
                    url={t.value}
                    key={i}
                    onClick={this.openFileUpload.bind(this, i)}
                    handleDeleteImage={this.handleDeleteImage.bind(this, i)}
                  />
                )
              )
          )}
          {thumbs.length < max &&
            ((Icon &&
              thumbs.length < 1 && (
                <Icon onClick={this.openFileUpload.bind(this, thumbs.length)} />
              )) || (
              <span
                className="drop-zone-placeholder"
                onClick={this.openFileUpload.bind(this, thumbs.length)}
              >
                <AddIcon />
              </span>
            ))}
        </Dropzone>
      </span>
    )
  }
}

MultipleImageField.propTypes = {
  source: PropTypes.string.isRequired,
  max: PropTypes.number
}

MultipleImageField.defaultProps = {
  max: 5
}

export default MultipleImageField
